export enum EnvModeType {
    LOCAL,
    MFLocal,
    DEV,
    DEMO,
    QA,
    UAT,
    STAGING,
    PROD,
}
